export default __webpack_public_path__ + "static/media/empty-state-upload-file.f889be77.svg";